import React from 'react';

import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';

import type { TransferMethodsMap, TransferMethodsProps } from './transferMethods.types';
import { buildTransferMethodsMap } from './transferMethods.utils';
import styles from './TransferTable.module.css';

export const TransferTable = ({ transferMethods = [] }: TransferMethodsProps) => {
    const columnWidth = `${100 / (transferMethods.length + 1)}%`;
    const methodsMap: TransferMethodsMap = buildTransferMethodsMap(transferMethods);
    const allRowTitles = Object.keys(methodsMap);

    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th className={styles.tableHeaderCell} style={{ width: columnWidth }}></th>
                        {transferMethods.map((method) => (
                            <th key={method.id} className={styles.tableHeaderCell} style={{ width: columnWidth }}>
                                {method.method_icon && (
                                    <img className={styles.headerIcon} src={method.method_icon.url} alt={method.method_name} title={method.method_name} />
                                )}
                                <PromoText tag={'div'} variant={'h4'} gradientColor={'aubergine04'}>
                                    {method.method_name}
                                </PromoText>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {allRowTitles.map((title, index) => (
                        <tr key={index}>
                            <td className={styles.tableCell} style={{ width: columnWidth }}>
                                <div className={styles.tableCellContainer}>
                                    <PromoText tag={'div'} variant={'h4'} gradientColor={'aubergine04'}>
                                        {title}
                                    </PromoText>
                                </div>
                            </td>
                            {transferMethods.map((method, methodIndex) => (
                                <td key={method.id} className={styles.tableCell} style={{ width: columnWidth }}>
                                    <PromoText tag={'div'} color={'gray80'}>
                                        {methodsMap[title]?.[methodIndex] || '—'}
                                    </PromoText>
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
